import { getDefaultLocaleOptions } from "../get-default-options/get-default-options.js";
import { DateTimeFormat } from "../intl-date-time/date-time-format.js";
import { getLocale, getVerifiedDate, } from "../shared-utils.js";
/**
 * Get localized Date and Time parts
 * @param {Date | number} date dateTime object, defaults to now if not set
 * @param {string | string[]} locale country code, BCP 47 language string, or array of either - default to 'en-US' if not set
 * @param {BetterDateTimeFormatOptions} options standard dateTimeFormat options object
 *  reference at https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @returns {Array} array of DateTimeFormatPart objects
 * @deprecated Use polyfill solution instead (see README.md)
 * ```js
 * import "@tesla/intl-date-time/polyfill.js";
 *
 * const date = new Date(Date.UTC(2020, 11, 20, 3, 23, 16, 738));
 * const formatter = new Intl.DateTimeFormat("en-US", { dateStyle: "medium" });
 * const output = formatter.formatToParts(date);
 * expect(result).toEqual([
 *   { type: "month", value: "Dec" },
 *   { type: "literal", value: " " },
 *   { type: "day", value: "19" },
 *   { type: "literal", value: ", " },
 *   { type: "year", value: "2020" },
 * ]);
 * ```
 */
export const getDateTimeParts = (date, locale, options) => {
    // ensure we have a locale
    const newLocale = getLocale(locale);
    // check if any locale-specific options
    const newOptions = options ? options : getDefaultLocaleOptions("dateTime", newLocale);
    return new DateTimeFormat(newLocale, newOptions).formatToParts(getVerifiedDate(date));
};
